import React, { useEffect, useContext, useState } from "react";
import { TeamsFxContext } from "../Context";
import { useGetLoginUrl } from "../../hooks/useGetLoginUrl";
import { useLocation } from "react-router-dom";
import { Constants } from "../../common/constants";
import { Sites } from "../../types/CommonTypes";

// The popup used to login to Teamcenter
const TeamcenterAuthPopup: React.FunctionComponent = () => {
  const teamsContext = useContext(TeamsFxContext);

  const [userAadOid, setUserAadOid] = useState<string>("");

  teamsContext?.teamsUserCredential?.getUserInfo().then((userInfo: any) => {
    setUserAadOid(userInfo?.objectId);
  });

  // Used useLocation here to read the siteId that gets passed as query parameter in urlString in authenticationUtils
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const siteId = searchParams.get(Constants.cacheSiteId);
  const siteDisplay = searchParams.get(Constants.cacheSiteDisplay);
  const appName = searchParams.get(Constants.cacheAppName) || "";
  const tokenSid = searchParams.get(Constants.tokenSid) || "";
  const appDeploymentId =
    searchParams.get(Constants.cacheAppDeploymentId) || "";
  const tcVersion = searchParams.get(Constants.cacheTcVersion) || "default";

  useEffect(() => {
    if (siteId && siteDisplay && appDeploymentId) {
      const selectedSite: Sites = {
        siteId: siteId,
        siteDisplay: siteDisplay,
        appDeploymentId: appDeploymentId,
        appName: appName,
      };
      localStorage.setItem(
        Constants.cacheSelectedSite,
        JSON.stringify(selectedSite)
      );
    } else {
      const selectedSite: Sites = {
        siteId: "",
        siteDisplay: "",
        appDeploymentId: appDeploymentId,
        appName: appName,
      };
      localStorage.setItem(
        Constants.cacheSelectedSite,
        JSON.stringify(selectedSite)
      );
    }
    localStorage.setItem(Constants.cacheTcVersion, tcVersion);
  }, [siteId, siteDisplay, appDeploymentId, tcVersion]);

  const { isFetched, url } = useGetLoginUrl(userAadOid, tokenSid);

  useEffect(() => {
    if (url) {
      window.location.assign(url);
    }
  }, [isFetched, url]);

  return <></>;
};

export default TeamcenterAuthPopup;
